// extracted by mini-css-extract-plugin
export default {"divider":"myCV_divider__m0H9B"};